import React, { useEffect, useState, useContext } from "react";
import { useParams, useHistory } from "react-router-dom";
import InstanceLeftSidebar from "../../InstanceLeftSidebar";
import PageHeaderWithBreadcrumbs from "../../../../components/PageHeaderWithBreadcrumbs";
import { AuthContext } from "../../../../helpers/AuthContext";
import './style.css'


//import './style.css';
import GlobalSettingsTabs from "../../../../components/GlobalTabs";
const InstanceGlobalSettings = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [updates, setUpdates] = useState([]);
  const [newStatus, setNewStatus] = useState("");
  const { authState } = useContext(AuthContext);
  let history = useHistory();
  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    { field: 'storeName', headerName: 'Store Name', width: 200 },
    { field: 'contactPerson', headerName: 'Contact Person', width: 180 },
    { field: 'email', headerName: 'Email', width: 250 },
    { field: 'phone', headerName: 'Phone', width: 150 },
    { field: 'address', headerName: 'Address', width: 300 },
    { field: 'website', headerName: 'Website', width: 220 },
    { field: 'status', headerName: 'Status', width: 150 },
    { field: 'created', headerName: 'Created At', width: 180 },
    { field: 'lastUpdated', headerName: 'Last Updated', width: 180 },
  ];

  // Define rows (example data for web stores)
  const rows = [
    { id: 1, storeName: 'PromoGear Co.', contactPerson: 'John Doe', email: 'john.doe@promogear.com', phone: '(555) 123-4567', address: '123 Gear St, Springfield', website: 'www.promogear.com', status: 'Active', created: '2024-01-15', lastUpdated: '2025-02-01' },
    { id: 2, storeName: 'GearUp Promotions', contactPerson: 'Jane Smith', email: 'jane.smith@gearup.com', phone: '(555) 987-6543', address: '456 Oak Ave, Greenfield', website: 'www.gearup.com', status: 'Inactive', created: '2023-09-12', lastUpdated: '2024-12-22' },
    { id: 3, storeName: 'PromoKing', contactPerson: 'Sam Wilson', email: 'sam.wilson@promoking.com', phone: '(555) 321-7890', address: '789 Pine Rd, Lakeview', website: 'www.promoking.com', status: 'Active', created: '2024-02-05', lastUpdated: '2025-01-30' },
    { id: 4, storeName: 'BrandBoosters', contactPerson: 'Lisa Adams', email: 'lisa.adams@brandboosters.com', phone: '(555) 654-3210', address: '101 Maple Dr, Rivertown', website: 'www.brandboosters.com', status: 'Pending', created: '2023-11-18', lastUpdated: '2024-01-28' },
    { id: 5, storeName: 'Corporate Swag', contactPerson: 'David Brown', email: 'david.brown@corporateswag.com', phone: '(555) 432-9876', address: '202 Birch Blvd, Hilltop', website: 'www.corporateswag.com', status: 'Active', created: '2024-03-01', lastUpdated: '2025-01-25' },
    { id: 6, storeName: 'SwagTech', contactPerson: 'Emily Green', email: 'emily.green@swagtech.com', phone: '(555) 876-5432', address: '303 Cedar Ln, Clearview', website: 'www.swagtech.com', status: 'Inactive', created: '2022-06-30', lastUpdated: '2024-12-11' },
    { id: 7, storeName: 'PromoWorks', contactPerson: 'Michael Johnson', email: 'michael.johnson@promoworks.com', phone: '(555) 654-7890', address: '404 Elm St, Birchwood', website: 'www.promoworks.com', status: 'Active', created: '2024-01-10', lastUpdated: '2025-02-02' },
    { id: 8, storeName: 'CustomSwag Shop', contactPerson: 'Olivia Lee', email: 'olivia.lee@customswag.com', phone: '(555) 210-6543', address: '505 Willow Rd, Sunnyside', website: 'www.customswag.com', status: 'Pending', created: '2023-10-05', lastUpdated: '2024-08-16' },
    { id: 9, storeName: 'BrandedGear Hub', contactPerson: 'James Carter', email: 'james.carter@brandedgear.com', phone: '(555) 876-2341', address: '606 Redwood Blvd, Westfield', website: 'www.brandedgear.com', status: 'Active', created: '2023-12-03', lastUpdated: '2025-01-18' },
    { id: 10, storeName: 'PromoMaxx', contactPerson: 'Sophia Mitchell', email: 'sophia.mitchell@promomaxx.com', phone: '(555) 987-4321', address: '707 Oakwood Dr, Eastview', website: 'www.promomaxx.com', status: 'Inactive', created: '2024-02-01', lastUpdated: '2024-12-05' },
  ];

  useEffect(() => {
    setLoading(false);
  }, []);

  const handlePostStatus = () => {
    if (newStatus.trim() !== "") {
      const newUpdate = {
        id: updates.length + 1,
        title: 'New Status Update',
        content: newStatus,
        timestamp: new Date().toLocaleString(),
        role: 'Employee',
        comment: 'No comments yet.',
        commentAuthor: 'You',
        tag: 'General',
        avatar: 'https://via.placeholder.com/40',
      };
      setUpdates([newUpdate, ...updates]);
      setNewStatus("");
    }
  };

  return (
    <div className="instance-dashboard">
      <InstanceLeftSidebar />
      <div className="rightSide">
        <div className="options-container fade-in-effect-usability">
          <div className="options-inner-container">
            <PageHeaderWithBreadcrumbs
              title="Global settings"
              breadcrumb="Global settings"
              includeButton={false}
            />
            <GlobalSettingsTabs/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstanceGlobalSettings;
